import { render, staticRenderFns } from "./PFLoansImport.vue?vue&type=template&id=3ae8c967"
import script from "./PFLoansImport.vue?vue&type=script&lang=js"
export * from "./PFLoansImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports